import { PayScheduleDetail } from '@xemplo/gp-types';

import { formatDaysBeforePayDay } from '../shared/card-helpers';

export function getFieldsArray(payscheduleData: PayScheduleDetail) {
  const {
    amendmentDueInDays,
    amendmentDueTime,
    payrunPreparationDueInDays,
    payrunPreparationDueTime,
    approvalDueInDays,
    approvalDueTime,
    paymentDueInDays,
    paymentDueTime,
    companyName,
    businessUnitName,
    payrollModelName,
    finaliseDueInDays,
    finaliseDueTime,
  } = payscheduleData;
  return [
    {
      id: 'amendments-due',
      label: 'Amendments Due',
      value: formatDaysBeforePayDay(amendmentDueInDays, amendmentDueTime),
    },
    {
      id: 'company',
      label: 'Company',
      value: companyName,
    },
    {
      id: 'pay-run-preparation-due',
      label: 'Pay Run Preparation Due',
      value: formatDaysBeforePayDay(payrunPreparationDueInDays, payrunPreparationDueTime),
    },
    {
      id: 'business-unit',
      label: 'Business Unit',
      value: businessUnitName,
    },
    {
      id: 'approval-due',
      label: 'Approval Due',
      value: formatDaysBeforePayDay(approvalDueInDays, approvalDueTime),
    },
    {
      id: 'finalise-due',
      label: 'Finalise Due',
      value: formatDaysBeforePayDay(finaliseDueInDays, finaliseDueTime),
    },
    {
      id: 'business-model',
      label: 'Business Model',
      value: payrollModelName,
    },
    {
      id: 'payment-due',
      label: 'Payment Due',
      value: formatDaysBeforePayDay(paymentDueInDays, paymentDueTime),
    },
  ];
}
